import * as z from "zod";
import { EvidenceId } from "../../tools/schemas/evidence";

export const MAX_CITATIONS = 50;

export namespace Request {
	export const schema = z.strictObject({
		ids: z.array(EvidenceId.schema).min(1).max(MAX_CITATIONS),
	});
}
export type Request = z.infer<typeof Request.schema>;

export namespace Item {
	export const schema = z.strictObject({
		id: EvidenceId.schema,
		title: z.string(),
		detail: z.string().nullable(),
	});
}
export type Item = z.infer<typeof Item.schema>;

export namespace Response {
	export const schema = z.strictObject({
		items: z.array(Item.schema),
		/**
		 * Requested ids whose record no longer resolves on the conversation's account. An id in
		 * neither list has no resolver for its kind, so it is not known to be gone.
		 */
		missing: z.array(EvidenceId.schema),
	});
}
export type Response = z.infer<typeof Response.schema>;
